module.exports = __webpack_public_path__ + "static/media/five.e4368f84.png";